const getters = {
  attendance(state) {
    return state.Attendance;
  },

  agentAvailableChannels(state) {
    if (!state.Attendance.channels) return [];
    return Object.keys(state.Attendance.channels).map((channel) => {
      if (channel) return channel;
    });
  },
  isUserAdded(state) {
    let userAdded = state.UserAdded;

    if (typeof userAdded.agentId == 'undefined') {
      userAdded = false;
    } else {
      if (userAdded.event == 'VoiceConferenceStopEvent') {
        userAdded = false;
      } else {
        userAdded = true;
      }
    }

    return userAdded;
  },
  timeInformationsTotalLoginTime(state) {
    if (!state.Attendance.timeInformations) return 0;
    const totalLogin = state.Attendance.timeInformations.totalLoginTimeDuration;
    return totalLogin || 0;
  },

  timeInformationsVoiceAvailable(state) {
    if (!state.Attendance.timeInformations) return 0;
    const totalLogin = state.Attendance.timeInformations.voice.totalLoggedTime;
    return totalLogin || 0;
  },

  timeInformationsWhatsAppAvailable(state) {
    if (!state.Attendance.timeInformations) return 0;
    const totalLogin =
      state.Attendance.timeInformations.whatsapp.totalLoggedTime;
    return totalLogin || 0;
  },

  timeInformationsVoiceInAttendance(state) {
    if (!state.Attendance.timeInformations) return 0;
    return state.Attendance.timeInformations.voice.activeAttendances;
  },

  timeInformationswhatsAppPaused(state) {
    if (!state.Attendance.timeInformations) return 0;
    return state.Attendance.timeInformations.whatsapp.pausesTime;
  },

  timeInformationsVoicePaused(state) {
    if (!state.Attendance.timeInformations) return 0;
    return state.Attendance.timeInformations.voice.pausesTime;
  },

  avatarAttendancePath(state) {
    const avatarAttendance = state.Attendance.avatar;
    if (!avatarAttendance) return require('@/assets/img/avatar-weon.png');
    const url =
      process.env.NODE_ENV == 'development'
        ? process.env.API_URL
        : window.CONFIG.weactionapi.url;
    return url.slice(0, -1) + avatarAttendance.path;
  },
};

export default getters;
